
import React from 'react';
import ReactDOM from "react-dom";
import swal from "sweetalert";
import FusionCharts from "fusioncharts/core";
import Bar3D from 'fusioncharts/viz/bar3d';
import Column3D from 'fusioncharts/viz/column3d';
import Pie2D from 'fusioncharts/viz/pie2d';
import NumberFormat from "react-number-format";
import Cylinder from 'fusioncharts/viz/cylinder';
import FusionTheme from 'fusioncharts/themes/es/fusioncharts.theme.fusion'

FusionCharts.addDep(Cylinder);
FusionCharts.addDep(Column3D);
FusionCharts.addDep(Bar3D);
FusionCharts.addDep(Pie2D);
FusionCharts.addDep(FusionTheme);

class RedeemedPromos extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            update: false,
            daysChart: {},
            agesChart: {},
            redeemedChart: {},
            total_promo: 0,
            redeemed_promo: 0,
            name_promo: ""
        };
    }

    componentWillMount()
    {
        let self = this;
    }

    componentDidMount()
    {
        let self = this;
        let month_url = "";

        switch (month) {
            case "enero": month_url = "01"; break;
            case "febrero": month_url = "02"; break;
            case "marzo": month_url = "03"; break;
            case "abril": month_url = "04"; break;
            case "mayo": month_url = "05"; break;
            case "junio": month_url = "06"; break;
            case "julio": month_url = "07"; break;
            case "agosto": month_url = "08"; break;
            case "septiembre": month_url = "09"; break;
            case "octubre": month_url = "10"; break;
            case "noviembre": month_url = "11"; break;
            case "diciembre": month_url = "12"; break;
        }

        if (year >= 2023) {
            axios.get('/api/_reports/' + month_url + '/' + year + '/promos_redeemed')
            .then(response => {
                let promos = response.data.promos;
                let labels = [];
                let values = [];
                let data = [];

                for (let i = 0; i < promos.length; i++) {
                    let data_json = {
                        label: promos[i].name,
                        value: promos[i].redeemed,
                    };

                    data.push(data_json);
                }

                console.log(data);

                const dataSource = {
                    "chart": {
                        "yaxisname": "Códigos entregados",
                        "theme": "fusion",
                        "bgColor": "#ffffff",
                        "palettecolors": "3D00BE, E5C225, CF0000, F54687, 00EC66, 006D3E, 6DB3BF, FF0000",
                        "showBorder": "1",
                        "showPlotBorder": "0",
                        "showCanvasBorder": "0",
                        "borderThickness": "0",
                        "canvasPadding": "0",
                        "usePlotGradientColor": "0",
                    },
                    "data": data
                };

                FusionCharts.ready(function() {
                    let myChart = new FusionCharts({
                        type: "bar3d",
                        renderAt: "redeemed-chart",
                        width: "100%",
                        height: "80%",
                        dataFormat: "json",
                        dataSource
                    }).render();
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });
        }
    }

    renderModalDetails()
    {
        let self = this;
        let total = self.state.total_promo;
        let redeemed = self.state.redeemed_promo;

        if (total !== 0)
        return (
            <div className="modal fade" tabIndex="-1" role="dialog"
                 aria-labelledby="myLargeModalLabel" aria-hidden="true" id="promodetailsModal">
                <div className="modal-dialog modal-full">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            <h4 className="modal-title" id="myLargeModalLabel">Detalles de {this.state.name_promo}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-2 col-xs-12">
                                    <h4 className="text-dark"
                                        style={{ fontSize: "large", fontWeight: "bold" }}>
                                        Códigos restantes
                                    </h4>
                                    <div className="row">
                                        <div className="col-lg-11 col-xs-6 col-xs-offset-3">
                                            <div id="cylinder_promo_details"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xs-12">
                                    <h4 className="text-dark"
                                        style={{ fontSize: "large", fontWeight: "bold" }}>
                                        Asignación por día
                                    </h4>
                                    <div id="days_promo_details"></div>
                                </div>
                                <div className="col-md-4 col-xs-12">
                                    <h4 className="text-dark"
                                        style={{ fontSize: "large", fontWeight: "bold" }}>
                                        Rango de edades
                                    </h4>
                                    <div id="ages_promo_details"></div>
                                </div>
                                <div className="col-md-2 col-xs-12">
                                    <div className="card-box widget-box-1 bg-white">
                                        <h4 className="text-dark"
                                            style={{ fontSize: "large", fontWeight: "bold" }}>
                                            Códigos totales
                                        </h4>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <h1 className="text-primary text-center"
                                                    style={{ fontSize: "-webkit-xxx-large", fontWeight: "bold" }}>
                                                    <NumberFormat value={total} displayType={'text'} thousandSeparator={true}/>
                                                </h1>
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>

                                    <div className="card-box widget-box-1 bg-white">
                                        <h4 className="text-dark"
                                            style={{ fontSize: "large", fontWeight: "bold" }}>
                                            Códigos entregados
                                        </h4>
                                        <br />
                                        <div className="col-md-12">
                                            <div className="row">
                                                <h1 className="text-warning text-center"
                                                    style={{ fontSize: "-webkit-xxx-large", fontWeight: "bold" }}>
                                                    <NumberFormat value={redeemed} displayType={'text'} thousandSeparator={true}/>
                                                </h1>
                                                <h1 className="text-warning text-center"
                                                    style={{ fontSize: "xx-large", fontWeight: "bold" }}>
                                                    {((redeemed*100)/(total)).toFixed(2)} %
                                                </h1>
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>

                                    <div className="card-box widget-box-1 bg-white">
                                        <h4 className="text-dark"
                                            style={{ fontSize: "large", fontWeight: "bold" }}>
                                            Códigos disponibles
                                        </h4>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <h1 className="text-success text-center"
                                                    style={{ fontSize: "-webkit-xxx-large", fontWeight: "bold" }}>
                                                    <NumberFormat value={total - redeemed} displayType={'text'} thousandSeparator={true}/>
                                                </h1>
                                                <h1 className="text-success text-center"
                                                    style={{ fontSize: "xx-large", fontWeight: "bold" }}>
                                                    {(100 - ((redeemed*100)/total)).toFixed(2)} %
                                                </h1>
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render()
    {
        let self = this;

        return (
            <div>
                {this.renderModalDetails()}
                <div id='redeemed-chart'></div>
            </div>
        );
    }
}

export default RedeemedPromos;

if (document.getElementById('redeemed_chart-component-v2')) {
    RedeemedPromosContainer = ReactDOM.render(<RedeemedPromos />, document.getElementById('redeemed_chart-component-v2'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/dashboardv2/RedeemedPromos.jsx